module.exports = __webpack_public_path__ + "img/Sparkle.6ceed8a0.svg";